import { TariffDto, TariffSearchRequest, UpsertTariffDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/tariffs`;

export const getTariffs = (source: CancelTokenSource): Promise<Array<TariffDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};


export const getAllTariffs = (source: CancelTokenSource): Promise<Array<TariffDto>> => {
  return axios
      .get(`${apiUri}/active`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllBasicTariffTypes = (source: CancelTokenSource): Promise<Array<TariffDto>> => {
  return axios
      .get(`${apiUri}/basic`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllTarmedTariffTypes = (source: CancelTokenSource): Promise<Array<TariffDto>> => {
  return axios
      .get(`${apiUri}/tarmed`, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchTariffTypes = (tariffSearchRequest: Partial<TariffSearchRequest>,
                                  source: CancelTokenSource): Promise<Array<TariffDto>> => {
  return axios
      .post(`${apiUri}/search`, tariffSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findTariffTypeById = (id: number, source: CancelTokenSource): Promise<UpsertTariffDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then( response => response.data)
};

export const addTariffType = (upsertTariffDto: Partial<UpsertTariffDto>, source: CancelTokenSource): Promise<TariffDto> => {
  return axios
      .post(apiUri, upsertTariffDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editTariffType = (id: number, upsertTariffDto: Partial<UpsertTariffDto>,
                               source: CancelTokenSource): Promise<TariffDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertTariffDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteTariffType = (id: number, source: CancelTokenSource): Promise<TariffDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};


